import React from "react";
import { styled } from "styled-components";
import { categories } from "../data";
import CategoryItem from "./CategoryItem";

const Categories = () => {
  return (
    <Container id="categories">
      {categories.map((item) => (
        <CategoryItem item={item} key={item.id} />
      ))}
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  display: flex;
  /* padding: 15px; */
  justify-content: space-between;
  scroll-snap-align: center;
  align-items: center;
`;

export default Categories;
